import Ajv from 'ajv';
import * as BusinessScheme from './scheme.json';

const ajv = new Ajv();
export const BusinessValidator = ajv.compile(BusinessScheme);
